import './dev.scss';
import data from './formatted-flat-keys.json';
import { Filters } from './Filters';
import { analytics } from './analytics';
// import { convertToJSON } from './util/convertXLSX.js';
import { polyfills } from './forEachPolyfill';

(function(){
	if (process.env.NODE_ENV !== 'production') {
		// require('./template.html');
		console.log('Looks like we are in development mode!');
	}

	polyfills();

	function digitalTools(tools){
		var filterBtns = document.querySelectorAll("button.filter-block-toggle"),
			container = document.getElementById("result-container"),
			modal = document.querySelector(".modal__card"),
			modal2 = document.querySelector(".modal__two"),
			card = modal.querySelector("div");

		// check for mobile
		function mobile(){
			let mql = window.matchMedia('(max-width:781px)'); 
			
			return mql.matches;
		}

		function tablet(){
			let mql = window.matchMedia('(min-width:782px) and (max-width:1023px)'); 
			
			return mql.matches;
		}

		// toggle filter menus
		filterBtns.forEach((btn,i) => {
			btn.addEventListener("click", () => {
				let parent = btn.parentElement,
					block = parent.querySelector(".filter-block__options"),
					openBlocks = document.querySelectorAll('.filter-opened'),
					boxHeight = [];

				openBlocks.forEach(open => {
					if (open == btn.parentElement) { return }
					open.classList.remove("filter-opened");
					open.querySelector(".filter-block__options").style = null;
				});

				if (parent.classList.contains("filter-opened")) {
					block.style = null;
					parent.classList.remove("filter-opened")
				} else {
					parent.classList.add("filter-opened");

					block.querySelectorAll(`.${block.classList} > *`).forEach(x => {
						boxHeight.push(x.clientHeight + 16);
					});

					block.style.height = `${boxHeight.reduce((a,b) => a + b, 0)}px`;
				}
			})

			if (i == 0 && !tablet() && !mobile()) { btn.click() }
		});

		// build preview cards
		function buildPreviewCards(dataset) {
			let desktopTotal = document.getElementById("title--totals");

			container.innerHTML = "";

			const previewCard = {
				clickCard(d){
					let label = d["name"].toLowerCase().replace(/\s|\-/gi, "_").replace("’", "");

					buildExpanded(d);
					console.log(label);
					// analytics("card_click", label);
				},
				createCard(data){
					const template = document.getElementById("preview__template").cloneNode(["deep"]);

					let cardLeadingInfo = template.querySelector(".card--leading"),
						cardTitle = cardLeadingInfo.querySelector("h2"),
						cardLocation = cardLeadingInfo.querySelector("h3.card__location"),
						cardPurposeTags = cardLeadingInfo.querySelector(".card--purpose-container"),
						cardInterventionTags = template.querySelector("#tags__intervention .card--tags__info"),
						cardTypeTags = template.querySelector("#tags__types .card--tags__info");

					cardTitle.innerText = `${data["name"]}`;
					template.id = `tool_${data.id}`;
					cardLocation.innerText = `${data.data.location[1].split("Currently: ")[1]}`;


					cardPurposeTags.innerHTML = this.addPurposeTags(data);
					cardInterventionTags.innerHTML = this.addInterventionTags(data).join('');
					cardTypeTags.innerHTML = this.addTypeTags(data).join('');

					template.addEventListener("click", () => {
						this.clickCard(data);
					})

					return template;
				},
				addPurposeTags(d){
					let type = d.data.purpose.toLowerCase();

					if (type == "a") {
						return `<span class="purpose__tag purpose-type__a">Data Collection</span>`
					} else if (type == "b") {
						return `<span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__b">Data Analysis & Visualization</span>`
					} else if (type == "c") {
						return `<span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__c">Learning Content Delivery</span>`
					} else if (type == "d") {
						return `<span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__b">Data Analysis & Visualization</span><span class="purpose__tag purpose-type__c">Learning Content Delivery</span>`;
					}
				},
				addInterventionTags(d){
					let interventionTypes = d.data["intervention-type"];
					return interventionTypes.map(item => {
						return `<span class="tag-response__intervention">${item.label}</span>`
					});
				},
				addTypeTags(d){
					let types = d.data.type;
					return types.map(item => {
						return `<span class="tag-response__types">${item.label}</span>`
					});
				}
			}

			// catch the cases where a user has drilled down to zero results
			if (dataset.length == 0) {
				let message = document.createElement("div"),
					reset = document.createElement("button");

				message.setAttribute("class", "cue--message");
				message.innerText = "There are no tools matching your filter criteria.";
				reset.setAttribute("class", "cue--reset");
				reset.innerText = "Clear filter selections";

				reset.addEventListener("click", () => {
					let filterSelection = document.querySelectorAll("input:checked"),
						filterPill = document.querySelectorAll("#results--active-filters .filter--pill"),
						filterClearBtn = document.querySelector("#results--active-filters .filter--controls"),
						resetBtn = new FilterBtn;

					filterSelection.forEach(x => {
						x.checked == true ? x.checked = false : "";

						Filters.clearAllFilters();
	 				});

	 				filterPill.forEach(pill => { pill.remove() });
	 				filterClearBtn.classList.remove("activated");
	 				resetBtn.filterList(data);
				})

				message.appendChild(reset);
				container.appendChild(message);
			} else if (dataset.length <= 4) {
				container.classList = `show-${dataset.length}-short-cards`;
			} else if (dataset.length > 4 && dataset.length < 8) {
				container.classList = `show-desktop-short-cards`;
			} else {
				container.classList = "";
			}

			// if there is data to show, build each of the cards
			dataset.forEach(x => {
				container.appendChild(previewCard.createCard(x));
			});

			// update displayed totals
			desktopTotal.innerText = dataset.length;
		}

		class Modal {
			constructor(modal, card, close){
				this.modal = modal;
				this.card = modal.classList.contains("modal__two") ? document.getElementById("digitools--filters") : this.modal.appendChild(card);
				this.close = this.card.querySelector(".modal__close");
				this.opened = false
			}
			disableScroll(){
				document.querySelector("body").classList.add("digitools-modal--open");
			}
			enableScroll(){
				document.querySelector("body").classList.remove("digitools-modal--open");
				window.onscroll = function(){};
			}
			events(){
				this.modal.addEventListener("click", () => {
					this.closeModal();
				});

				this.card.addEventListener("click", e => {
					e.stopPropagation();
				});

				this.close.addEventListener("click", e => {
					this.closeModal();
				})
			}
			closeModal(){
				this.opened = false;
				this.enableScroll();
				this.modal.style.opacity = 0;
				this.card.id == "digitools--filters" ? this.slideLeft("#digitools--filters", "-100%") : "";

				setTimeout(() => { 
					this.modal.classList.remove("modal__open");
					this.modal.style = null;
				}, 350);
				
			}
			status(open){
				if (open == true) { 
					this.opened = true;
					this.modal.classList.add("modal__open");
					this.events(); 
					this.disableScroll();
					this.modal.scrollTo(0,0);
					setTimeout(() => { 
						this.modal.style.opacity = 1;
						this.card.id == "digitools--filters" ? this.slideLeft("#digitools--filters", 0) : "";
					}, 100);
				}
			}
			slideLeft(elem, distance) {
				let menu = this.modal.querySelector(`${elem}`);

				menu.style.left = distance;
			}	
		}

		class FilterModal extends Modal {
			constructor(modal, card, close){
				super(modal, card, close);
				this.clearButton = document.querySelector(".filter--clear__mobile");
			}
			status(open){
				super.status(true);

				if (open == true) {
					let firstFilter = this.card.querySelector(".filter-block-toggle");

					firstFilter.click();
				}
			}
			closeModal(){
				super.closeModal();
				let firstFilter = this.card.querySelector(".filter-block-toggle");

				// firstFilter.click();
			}
			clearFilters(){
				let filterSelection = document.querySelectorAll("input:checked"),
					filterClearContainer = document.querySelector("#results--active-filters .filter--controls"),
					filterPill = document.querySelectorAll("#results--active-filters .filter--pill"),
					mobileReset = new FilterBtn;

				filterSelection.forEach(x => {
					x.checked == true ? x.checked = false : "";
				});

				filterPill.forEach(pill => { pill.remove() });
				filterClearContainer.classList.remove("activated");

				Filters.clearAllFilters();
				mobileReset.filterList(data);
			}
			clearEvent(){
				var ref = this;

				this.clearButton.addEventListener("click", function(){
					ref.clearFilters();
				})
			}
		}

		class FilterBtn {
			constructor(value, group){
				this.val = value;
				this.group = group;
			}
			updateFilterLength(){
				let num = document.querySelector(".filter--count");

				num.innerText = Filters.length;
			}
			createPill(name, group){
				const template = document.getElementById("active-filter__template").cloneNode(["deep"]);
				let close = template.querySelector(".pill__close"),
					label = document.querySelector(`input[value='${name}'] + span + div.filter-option__name span.filter__${group}--label`).innerText;

				template.id = `id_${name}`;
				template.classList.add(`pill__${group}`);
				template.querySelector(".pill__name").innerText = label;

				close.addEventListener("click", () => {
					this.removePillFromList(template, group);
				})

				this.addPillToList(template);
			}
			addPillToList(pill){
				let container = document.getElementById("results--active-filters__pills"),
					filterClearContainer = document.querySelector("#results--active-filters .filter--controls");

				!filterClearContainer.classList.contains("activated") ? this.enableClearingAllFilters() : "";
				container.appendChild(pill);	
			}
			removePillFromList(pill, group){
				if (pill == undefined) { return }
				pill.remove();
			}
			filterList(data){
				container.classList.add("empty__animation");

				setTimeout(() => {
					let filters = Filters.getCurrentFilters(),
						filteredList;

						// console.log(filters);
					
					if (filters.length == 0) {
						filteredList = data;
					} else {
						filteredList = data.filter(d => {
							const condition = filters.find(o => { return o.key == "purpose" })?.value ?? d.data.purpose.toLowerCase();

							return d.data.purpose.toLowerCase() == condition;	
						});

						filteredList = filteredList.filter(e => {
							let match,
								intersection = [];

							for (let i = 0; i < filters.length; i++) {
								if (filters[i].key == "purpose") { 
									match = true;
								} else {
									const dataToMatch = Array.isArray(e.data[filters[i].key]) ? e.data[filters[i].key].map(a => a.key) : [e.data[filters[i].key]];

									intersection = dataToMatch.filter(el => {
										return filters[i].value.includes(el);
									});

									if (intersection.length > 0 ) {
										match = true;
									} else {
										return match = false;
									}
								}
							}
							return match;
						});
					}

					console.log(filteredList);

					buildPreviewCards(filteredList);
					this.updateFilterLength();
				}, 300);

				setTimeout(() => {
					container.classList.remove("empty__animation");
				}, 450);	
			}
			enableClearingAllFilters(){
				let filterClearContainer = document.querySelector("#results--active-filters .filter--controls"),
					allFilterClearBtn = document.getElementById("filter-clear__master");

				filterClearContainer.classList.add("activated");

				allFilterClearBtn.addEventListener("click", () => {
					this.clearAllFilters();
				})
			}
			clearAllFilters(){
				let filterSelection = document.querySelectorAll("input:checked"),
					filterClearContainer = document.querySelector("#results--active-filters .filter--controls"),
					filterPill = document.querySelectorAll("#results--active-filters .filter--pill");

				filterSelection.forEach(x => {
					x.checked == true ? x.checked = false : "";
				});

				filterPill.forEach(pill => { pill.remove() });
				filterClearContainer.classList.remove("activated");

				Filters.clearAllFilters();
				this.filterList(data);
			}
		}

		class Radio extends FilterBtn {
			constructor(value, group){
				super(value,group);
			}
			handleChange(e){
				Filters.changeSingle(this.val, this.group);

				// super.filterList(data);
				this.enableClearButton(e.target.parentElement.parentElement);
				super.filterList(data);
				super.removePillFromList(document.querySelector(`.pill__${this.group}`));
				super.createPill(this.val, this.group);
			}
			enableClearButton(category){
				var clearBtn = category.querySelector(".filter__clear");

				clearBtn.classList.add("activated");
				clearBtn.addEventListener("click", () => {
					this.clearSelections(category);
				})
			}
			clearSelections(category) {
				let name;

				category.querySelectorAll(".digitools--radio input").forEach((radio, i) => { 
					if (i == 0) { name = radio.name.split("filter__")[1] }
					radio.checked = false; 
				});

				category.querySelector(".filter__clear").classList.remove("activated");
				Filters.changeSingle("clear", name);
				super.filterList(data);
				super.removePillFromList(document.querySelector(`.pill__${name}`));
			}
			removePillFromList(){
				let category = document.querySelector(`#filter-block__${this.group} .filter-block__options`);
				
				this.clearSelections(category);
				super.removePillFromList(document.querySelector(`.pill__${this.group}`), this.val);
			}
		}

		class Checkbox extends FilterBtn {
			constructor(value,group){
				super(value,group);
			}
			handleChange(e){
				if (e.target.checked == true) {
					Filters.addToArray(this.val, this.group);
					super.filterList(data);
					super.createPill(this.val, this.group);
				} else if (e.target.checked == false) {
					this.removeFromFilters();
				}
			}
			removeFromFilters(){
					Filters.removeFromArray(this.val, this.group);
					super.filterList(data);
					super.removePillFromList(document.querySelector(`.pill__${this.group}`), this.val);
			}
			removePillFromList(){
				this.removeFromFilters();
				document.querySelector(`.digitools--checkbox input[name='filter__${this.group}'][value='${this.val}'`).checked = false;

				super.removePillFromList(document.querySelector(`.pill__${this.group} #id_${this.val}`), this.val);
			}
		}

		// set up filter controls and link them to classes
		function filterControls(){
			let radioBtns = document.querySelectorAll(".digitools--radio input"),
				checkBoxes = document.querySelectorAll(".digitools--checkbox input");

			function initializeRadioBtns(radios) {
				radios.forEach(radio => {
					radio.addEventListener("change", (e) => {
						analytics("filter", `type_${e.target.value}`);
						let r = new Radio(e.target.value, e.target.name.split("filter__")[1]);
						r.handleChange(e);
					})					
				})
			}

			function initializeCheckboxes(checkboxes) {
				checkboxes.forEach(checkbox => {
					checkbox.addEventListener("change", (e) => {
						let label = e.target.parentElement.querySelector(".filter-option__name").innerText;

						analytics("filter", label.toLowerCase());

						let check = new Checkbox(Number(e.target.value), e.target.name.split("filter__")[1]);
						check.handleChange(e);
					})
				})
			}


			// initialize all filter buttons
			initializeRadioBtns(radioBtns);
			initializeCheckboxes(checkBoxes);
		}

		// build expanded modal
		function buildExpanded(strategy){
			const template = document.getElementById("filter--card__expanded").cloneNode(["deep"]);

			modal.innerHTML = "";

			function fillCard(d){
				let title = template.querySelector("h2"),
					organization = template.querySelector("#expanded__organization"),
					location = template.querySelector("#expanded__location-current"),
					purpose = template.querySelector("#expanded__purpose"),
					description = template.querySelector(".expanded__description p"),
					details = template.querySelectorAll(".expanded__details .details__response");

				// fill in basic information
				title.innerText = d.name;
				organization.innerText = d.data.organization;
				location.innerText = d.data.location[1].split("Currently:")[1].trim();
				description.innerText = d.data.description;
				purpose.innerHTML = addPurposeTags(d.data.purpose);

				// fill in details
				details.forEach(x => {
					let category = x.id.split("details__")[1];

					if (category == "external-adoption") {
						x.innerText = d.data[category].join(" | ");
					} else if (Array.isArray(d.data[category])){
						let labels = d.data[category].map(c => {
							return c.label;
						});

						if (labels[0] == undefined) {
							x.innerText = d.data[category].join(", ");
						} else {
							x.innerText = labels.join(", ");
						}
						
					} else {
						x.innerText = d.data[category];
					}
				})

				// add purpose tags
				function addPurposeTags(d){
					// let type = d.toLowerCase();

					if (d.toLowerCase() == "a") {
						return `<div><span class="purpose__label">Type A</span></div><div><span class="purpose__tag purpose-type__a">Data Collection</span></div>`
					} else if (d.toLowerCase() == "b") {
						return `<div><span class="purpose__label">Type B</span></div><div><span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__b">Data Analysis & Visualization</span></div>`
					} else if (d.toLowerCase() == "c") {
						return `<div><span class="purpose__label">Type C</span></div><div><span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__c">Learning Content Delivery</span></div>`
					} else if (d.toLowerCase() == "d") {
						return `<div><span class="purpose__label">Type D</span></div><div><span class="purpose__tag purpose-type__a">Data Collection</span><span class="purpose__tag purpose-type__b">Data Analysis & Visualization</span><span class="purpose__tag purpose-type__c">Learning Content Delivery</span></div>`;
					}
				}
			}

			fillCard(strategy);

			const expandedCard = new Modal(modal, template, template.querySelector(".modal__close"));
			expandedCard.status(true);
		}

		// set up mobile slide out 
		function mobileFilterMenu(){
			let btn = document.getElementById("js--open-filters");

			btn.addEventListener("click", e => {
				const mobileMenu = new FilterModal(modal2, document.getElementById('finder--filters'), document.querySelector(".modal__close"));
				mobileMenu.status(true);
			})
		}

		mobileFilterMenu();
		buildPreviewCards(data);
		filterControls();
	}

	document.addEventListener('readystatechange', function() {
		document.readyState === 'complete' && digitalTools(data);
	}, false);
	// digitalTools(data);
	// convertToJSON();
})()
